import React from "react"
import L10n from "lib/carrot-l10n"
import LibraryMarkdown from "../library/LibraryMarkdown"
import { BackArrowLink } from "../molecules/Molecules"
import { Spacer } from "../atoms/Atoms"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyLayout } from "../atoms/layouts/BodyLayout"
import { Header } from "components/views/atoms/Header"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const WhatsImportantMain = () => (
  <>
    <H1 variant="dark">{l`whatsImportant`}</H1>
    <Spacer height={2} />
    <LibraryMarkdown source={l`providerFinder.whatsMostImportantWhenChoosing`} />
  </>
)

const WhatsImportantHeader = () => <Header titleBar={<BackArrowLink>{l`providerFinder`}</BackArrowLink>} />

const WhatsImportant = () => (
  <MasterLayout header={<WhatsImportantHeader />}>
    <BodyLayout>
      <WhatsImportantMain />
    </BodyLayout>
  </MasterLayout>
)

export default WhatsImportant
